import { graphql } from "react-relay";

export const query = graphql`
  query EventSchedulerTimeInputRendererQuery(
    $orgRelayId: ID!
    $query: SchedulingQueryInput!
    $rescheduler: Boolean!
    $reschedulerExternalEventId: String!
    $reschedulerTimeZone: String!
    $reschedulerRangeMin: DayTimeSlotInput!
    $reschedulerRangeMax: DayTimeSlotInput!
  ) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        ...EventSchedulerTimeInput_org
        schedulingResponseErrorable(query: $query) @skip(if: $rescheduler) {
          ...EventSchedulerTimeInput_schedulingResponseErrorable
        }
        reschedulingResponseErrorable(
          externalEventId: $reschedulerExternalEventId
          timeZone: $reschedulerTimeZone
          rangeMin: $reschedulerRangeMin
          rangeMax: $reschedulerRangeMax
        ) @include(if: $rescheduler) {
          ...EventSchedulerTimeInput_schedulingResponseErrorable
        }
        workingGroups(first: 1000000) {
          edges {
            node {
              id
              rooms {
                roomId
                name
              }
            }
          }
        }
      }
    }
  }
`;
